import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/type-stop"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    selectLisTypeReturn(){

        let params = new URLSearchParams()
        params.append("stepReturnEnabled","true")

        return this.selectList(params)

    }

    selectLisTypeStop(){

        let params = new URLSearchParams()
        params.append("productionBlockEnabled","true")

        return this.selectList(params)

    }

}

export default new service();


